import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import { i18n } from './i18n'

// Self-hosted Inter first, then the kit's tokens and its COMPILED component
// styles, then Influx's own.
//
// `style.css` is load-bearing in a published build and easy to miss locally:
// with the kit linked from source, Vite compiles each component's own <style>
// block and the UI looks right without it. The PUBLISHED package ships no .vue
// source — the component CSS is pre-built into dist/style.css and its JS entry
// does not import it — so a Docker build would render every kit component
// unstyled: correct markup and tokens, buttons with no padding or background.
import './assets/fonts.css'
import '@tribit-rs/ui-kit/globals.scss'
import '@tribit-rs/ui-kit/style.css'
import './assets/influx.scss'

const app = createApp(App)
app.use(router)
app.use(i18n)
app.mount('#app')
